
import { Options } from "vue-class-component";

import { Search, List } from "vant";

import BaseList from "@/common/BaseList";
import AppUtil from "@/util/AppUtil";

@Options({
  components: {
    [Search.name]: Search,
    [List.name]: List,
  },
})
/**商品订单 */
export default class RepaymentList extends BaseList {
  reqUrl = "/zhOrder/goodsOrder/getGoodsOrderList";
  _title = "商品订单";
  search_click() {
    this.reqData.page = 0;
    this.req_items();
  }
  protected init_item(val: any) {
    val.goods = JSON.parse(val.goodsJson);
    if (!val.goods) {
      val.goods = [];
    }
    // console.log(" val.goods", val.goods);

    return val;
    // console.log("val",val)
  }
}
